<template>
    <div class="d-flex flex-row w-100">
        <div class="leftcolumn mr-4">
            <div v-if="!jobLoading">
                <Paper class="p-4 mb-4">
                    <div class="jobtitle">{{ job.title }}</div>
                    <div class="d-flex align-items-align-items-start">
                        <div v-if="job.location" class="d-flex align-items-align-items-start">
                            <BaseIcon name="map-marker-alt" class="icon gray-color" />
                            <span class="subtitle my-2 mr-3">{{ job.location }}</span>
                        </div>
                        <div v-if="job.deadline" class="d-flex align-items-align-items-start">
                            <BaseIcon name="clock" class="icon gray-color" />
                            <span class="subtitle my-2">{{ formattedDeadline }}</span>
                        </div>
                    </div>
                </Paper>
                <Paper v-if="job.description" class="p-4 mb-4">
                    <div v-html="job.description"></div>
                </Paper>
            </div>
        </div>
        <div class="rightcolumn flex-grow-1">
            <CompanyBadge class="mb-4" :company="company" :routerLink="companyLink"></CompanyBadge>
            <DetailModule
                class="mb-4"
                :data="job"
                :isVerified="true"
                :isPending="false"
                :isLoading="jobLoading"
            />
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import Paper from '~/components/builders/Paper';
import CompanyBadge from './components/CompanyBadge';
import DetailModule from '~/views/jobdetail/components/DetailModule';
import AnalyticService from '~/services/AnalyticService';

export default {
    name: 'Job',
    data() {
        return {
            loading: false,
            hasLoggedEvent: false,
        };
    },
    components: {
        Paper,
        CompanyBadge,
        DetailModule,
    },
    computed: {
        postingRequest() {
            if (!this.$route.params.jobId) {
                return undefined;
            } else {
                return this.$interfaces.posting.id(this.$route.params.jobId).get({
                    reactive: true,
                    isJobAdId: true,
                });
            }
        },
        job() {
            if (!this.postingRequest || this.postingRequest.loading) {
                return null;
            } else {
                return this.postingRequest.data;
            }
        },
        jobLoading() {
            return !this.postingRequest || this.postingRequest.loading;
        },
        formattedDeadline() {
            const deadline = moment(this.job.deadline);
            return deadline.format('DD MMM YYYY');
        },
        companyLink() {
            if (this.job) {
                const url = this.$URLS.vfair
                    .concat('/', this.$route.params.id)
                    .concat('/companies/', this.job.companyId);
                return url;
            } else {
                return '';
            }
        },
        company() {
            if (this.job) {
                var request = this.$interfaces.vfair
                    .id(this.$route.params.id)
                    .organizations.organizationId(this.job.companyId)
                    .get({ reactive: true });
                if (request.loading) {
                    return {};
                } else {
                    return request.data;
                }
            } else {
                return {};
            }
        },
    },
    methods: {
        logJobadViewEvent() {
            // This triggers an Google Analytics event
            const data = this.job;
            if (data.jobAdId) {
                AnalyticService.jobadViewEvent(data.jobAdId, data.companyId, data.title);
                this.hasLoggedEvent = true;
            }
        },
    },
    watch: {
        job(newPosting, oldPosting) {
            // When the posting data has changed, the posting-data has loaded.
            // Log the posting-pageview if it has not been logged before, or
            // if the posting has changed (the ids have changed).
            if (newPosting && (!this.hasLoggedEvent || newPosting.jobAdId !== oldPosting.jobAdId)) {
                this.logJobadViewEvent();
            }
        },
    },
    mounted() {},
};
</script>

<style scoped>
.leftcolumn {
    width: 65%;
    margin-right: 22px;
}
.jobtitle {
    font-size: 18px;
}
.companytitle {
    font-size: 18px;
    text-align: center;
}
.logo {
    width: 180px;
    height: 70px;
    object-fit: contain;
}
</style>
